import { fetchAmberdataSeriesList } from '@/features/chart/lib/series-sources/amberdata-series'
import { normalizeBarTimeSec } from '@/lib/tradingview/datafeeds/chart-datafeed'
import {
  type ChartSeriesSource,
  SERIES_MIN_TIMEFRAME_SECONDS,
  type SeriesPoint,
} from '@/lib/tradingview/datafeeds/series-sources'
import { AnalyticsType } from '@/types/generated/common/types'
import type { PutCallRatioList } from '@/types/generated/public_api'

/** One Amberdata PCR point carries both ratios — one source, two metrics. */
export function putCallRatioListToSeriesPoints(list: PutCallRatioList | undefined): SeriesPoint[] {
  if (!list) return []
  const points: SeriesPoint[] = []
  for (const item of list.items) {
    const timeSec = normalizeBarTimeSec(Number(item.timestampMs))
    if (!Number.isFinite(timeSec)) continue
    const values: SeriesPoint['values'] = {}
    const oi = Number(item.putCallRatioOpenInterest)
    const volume = Number(item.putCallRatioVolume24h)
    if (Number.isFinite(oi)) values.putCallRatioOi = oi
    if (Number.isFinite(volume)) values.putCallRatioVolume = volume
    if (Object.keys(values).length > 0) points.push({ timeSec, values })
  }
  return points
}

export const putCallRatioSeriesSource: ChartSeriesSource = {
  id: 'putCallRatio',
  metrics: ['putCallRatioOi', 'putCallRatioVolume'],
  refresh: 'bar-close',
  minTimeframeSeconds: SERIES_MIN_TIMEFRAME_SECONDS,
  // Amberdata PCR granularity is coarser than most chart timeframes — plot
  // the last observation at-or-before each bar.
  carryForward: true,
  fetchHistory: async (ctx, signal) => {
    const list = await fetchAmberdataSeriesList(
      ctx,
      AnalyticsType.ANALYTICS_TYPE_PUT_CALL_RATIO,
      signal
    )
    return putCallRatioListToSeriesPoints(list as PutCallRatioList | undefined)
  },
}
